import * as z from 'zod';

const partialPlayerSchema = z
    .object({
        toParToday: z
            .object({
                displayValue: z.string(),
            })
            .nonstrict(),
    })
    .nonstrict();

export function getToParTodayDisplayValue(player: unknown): string {
    const validationResult = partialPlayerSchema.safeParse(player);

    if (!validationResult.success) {
        return '';
    }

    const partialPlayer = validationResult.data;

    return partialPlayer.toParToday.displayValue || '-';
}
